import React, { useState } from 'react';
import { UniversalLink, Icon } from '@plone/volto/components';
import { Pagination } from 'semantic-ui-react';
import clipSVG from '@plone/volto/icons/attachment.svg';
import './styles.css';

const CardListView = (props) => {
  const { data, items: propItems } = props;
  const [activePage, setActivePage] = useState(1);
  
  const cardStyle = data.cardStyle || 'simple';
  const verticalAlignment = data.verticalAlignment || 'left';
  const title = data.title || '';
  const showDots = data.showDots === 'yes';
  const dotsPosition = data.dotsPosition || 'both';
  const titleAlignment = data.titleAlignment || 'left';
  
  // Definisci items correttamente
  const allItems = Array.isArray(propItems) 
    ? propItems 
    : Array.isArray(data.items) 
      ? data.items 
      : [];

  // Gestione della paginazione
  const itemsPerPage = data.enablePagination ? data.itemsPerPage || 4 : data.resultsPerPage || 4;
  const totalPages = Math.ceil(allItems.length / itemsPerPage);
  const startIndex = (activePage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleItems = data.enablePagination 
    ? allItems.slice(startIndex, endIndex)
    : allItems.slice(0, itemsPerPage);

  return (
    <div className={`card-list-block block ${cardStyle}`}>
      {title && (
        <div className={`card-list-title ${titleAlignment}`}>
          {showDots && (dotsPosition === 'before' || dotsPosition === 'both') && (
            <span className="title-dots before">
              <span className="dot blue"></span>
              <span className="dot yellow"></span>
            </span>
          )}
          <h2>{title}</h2>
          {showDots && (dotsPosition === 'after' || dotsPosition === 'both') && (
            <span className="title-dots after">
              <span className="dot blue"></span>
              <span className="dot yellow"></span>
            </span>
          )}
        </div>
      )}
      
      <div className="card-grid">
        {visibleItems.length > 0 ? (
          visibleItems.map((item) => (
            <div key={item['@id']} className={`card ${cardStyle}`}>
              {cardStyle === 'vertical' ? (
                <div
                  className={`vertical-card-content ${
                    verticalAlignment === 'right' ? 'image-right' : 'image-left'
                  }`}
                >
                  {(item.image || item.image_field) && (
                    <div className="vertical-card-image-wrapper">
                      <img
                        src={
                          item.image?.scales?.preview?.download || 
                          `${item['@id']}/@@images/${item.image_field || 'image'}/preview`
                        }
                        alt={item.title || 'Immagine news'}
                        className="card-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          console.error('Errore caricamento immagine:', e.target.src);
                        }}
                      />
                    </div>
                  )}
                  <div className="vertical-card-text">
                    {data.contentType === 'News Item' && (
                      <div className="news-meta">
                        <span className="news-type">NOTIZIA - 
                          {item.created ? (
                            <span className="news-date">
                              {new Date(item.created).toLocaleDateString('it-IT', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric'
                              })}
                            </span>
                          ) : (
                            <span className="news-date">Data non disponibile</span>
                          )}
                        </span>
                      </div>
                    )}
                    <h3 className="card-title">
                      <UniversalLink href={item['@id']}>{item.title}</UniversalLink>
                    </h3>
                    <p className="card-text">{item.description}</p>
                    <div className="card-link-wrapper">
                      <UniversalLink 
                        href={item['@id']} 
                        className="card-link simple-link"
                      >
                        Scopri di più →
                      </UniversalLink>
                    </div>
                  </div>
                </div>
              ) : cardStyle === 'image' ? (
                <>
                  {(item.image || item.image_field) && (
                   
                      <img
                        src={
                          item.image?.scales?.preview?.download || 
                          `${item['@id']}/@@images/${item.image_field || 'image'}/preview`
                        }
                        alt={item.title}
                        className="card-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          console.error('Errore caricamento immagine:', e.target.src);
                        }}
                      />
                    
                  )}

                 
                  <h3 className="card-title">
                    <UniversalLink href={item['@id']}>{item.title}</UniversalLink>
                  </h3>
                  <p className="card-text">{item.description}</p>
                </>
              ) : cardStyle === 'attachments' ? (
                <div className="attachments-card-content">
                  <Icon name={clipSVG} size="24px" className="attachment-icon" />
                  <h3 className="card-title">
                    <UniversalLink href={`${item['@id']}/@@download/file`}>
                      {item.title}
                    </UniversalLink>
                  </h3>
                </div>
              ) : (
                <>
                  <h3 className="card-title">
                    <UniversalLink href={item['@id']}>{item.title}</UniversalLink>
                  </h3>
                  <p className="card-text">{item.description}</p>
                </>
              )}
            </div>
          ))
        ) : (
          <p>Nessun contenuto trovato per la tipologia selezionata.</p>
        )}
      </div>

      {data.enablePagination && totalPages > 1 && (
        <div className="pagination-wrapper">
          <Pagination
            activePage={activePage}
            totalPages={totalPages}
            onPageChange={(e, { activePage }) => setActivePage(activePage)}
            firstItem={null}
            lastItem={null}
            pointing
            secondary
          />
        </div>
      )}
    </div>
  );
};

export default CardListView;